export const DEFAULT_FONTS = Object.freeze({
	Arial: 'Arial',
	Helvetica: 'Helvetica',
	'Times New Roman': 'Times New Roman',
	Times: 'Times',
	'Courier New': 'Courier New',
	Courier: 'Courier',
	Verdana: 'Verdana',
	Georgia: 'Georgia',
	Palatino: 'Palatino',
	Garamond: 'Garamond',
	Bookman: 'Bookman',
	'Comic Sans MS': 'Comic Sans MS',
	'Trebuchet MS': 'Trebuchet MS',
	'Arial Black': 'Arial Black',
	Impact: 'Impact',
})
